import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-428fa112")

_pushScopeId("data-v-428fa112")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "justify-center d-flex" }
const _hoisted_3 = { class: "weight" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "KG", -1)
const _hoisted_5 = { class: "input-ground" }
const _hoisted_6 = {
  key: 0,
  class: "text-center",
  style: {"margin-top":"40px"}
}
const _hoisted_7 = { class: "table" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { colspan: "4" }, "成年人身体质量指数")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "过瘦"),
    /*#__PURE__*/_createVNode("th", null, "正常"),
    /*#__PURE__*/_createVNode("th", null, "过重"),
    /*#__PURE__*/_createVNode("th", null, "肥胖")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString($setup.kg), 1),
          _hoisted_4
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives(_createVNode("input", {
        type: "text",
        placeholder: "输入身高获取BMI（单位cm）",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.height = $event))
      }, null, 512), [
        [_vModelText, $setup.height]
      ]),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = (...args) => ($setup.getBMI(...args)))
      }, " 查看 ")
    ]),
    ($setup.bmi && $setup.bmi !== Infinity)
      ? (_openBlock(), _createBlock("div", _hoisted_6, " 当前BMI指数为 " + _toDisplayString($setup.bmi), 1))
      : _createCommentVNode("", true),
    _createVNode("table", _hoisted_7, [
      _hoisted_8,
      _createVNode("tbody", null, [
        _createVNode("tr", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.BMI_LIST, (item, index) => {
            return (_openBlock(), _createBlock("td", {
              key: item,
              class: { active: index === $setup.bmiIndex }
            }, _toDisplayString(item), 3))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
})